import React from 'react';
import { AdaptiveFilterBar } from '../../../../shared/components/patterns';
import { documentsFilterConfig } from './documentsPage.config';

export default function DocumentsFilters({
  categories,
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  selectedStatuses = [],
  onStatusesChange,
  onReset,
  activeOverviewFilter,
  onOverviewChange,
}) {
  const availableCategories = new Set(categories);
  const config = {
    ...documentsFilterConfig,
    groups: documentsFilterConfig.groups.map((group) => (
      group.key === 'category'
        ? {
            ...group,
            options: group.options.filter((option) => availableCategories.has(option.value)),
          }
        : group
    )),
  };

  function handleFilterChange(key, value) {
    if (key === 'overview') { onOverviewChange?.(value); return; }

    if (key === 'query') {
      onSearchChange?.(value);
      return;
    }

    if (key === 'category') {
      onCategoryChange?.(value || 'Tutti');
      return;
    }

    if (key === 'status') {
      onStatusesChange?.(Array.isArray(value) ? value : []);
    }
  }

  return (
    <AdaptiveFilterBar
      config={config}
      values={{
        overview: activeOverviewFilter === 'totalDocuments' ? '' : activeOverviewFilter || '',
        query: searchTerm,
        category: selectedCategory || 'Tutti',
        status: selectedStatuses,
      }}
      onChange={handleFilterChange}
      onReset={onReset}
      resetLabel="Reset filtri documenti"
      filtersLabel="Filtri documenti"
    />
  );
}
